import type { GraphemeGlyph } from "@-/dev.improve.haniverse.lib.morpheme.grapheme.entities";

export type WordGlyph = readonly GraphemeGlyph[];

export function createWordGlyph(
  glyphParamList: readonly {
    color: string | null;
    display: string;
    fontWeight?: GraphemeGlyph["fontWeight"];
    original: string;
  }[],
): WordGlyph {
  return glyphParamList.map((glyph) => ({
    ...glyph,
    fontWeight: glyph.fontWeight ?? "400",
  }));
}
